export const AssignmentToolStateList = "AssignmentToolStateList";
export const AssignmentToolCaseDetailsHeight = "AssignmentToolCaseDetailsHeight";
export const AssignmentToolFilterInspectionTypeGroup = "AssignmentToolFilterInspectionTypeGroup";
export const AssignmentToolFilterExtras = "AssignmentToolFilterExtras";
export const AssignmentToolFilterDue = "AssignmentToolFilterDue";
export const AssignmentToolFilterOrdered = "AssignmentToolFilterOrdered";
export const AssignmentToolFilterCounty = "AssignmentToolFilterCounty";
export const AssignmentToolAssignedCasesDaysOut = "AssignmentToolAssignedCasesDaysOut";
export const PhotoSizeSetting = "PhotoSizeSetting";
export const PhotoTagSetting = "PhotoTagSetting";
export const PhotoButtonSetting = "PhotoButtonSetting";
export const PhoenixFormsDesignerAddQuestionOrder = "PhoenixFormsDesignerAddQuestionOrder";
export const PhotoNumberingSetting = "PhotoNumberingSetting";
export const QACaseViewTabOrderPreference = "QACaseViewTabOrderPreference";
export const modeEnum = { READ_ONLY: 1, EDIT: 2 };
export const MinRequiredPasswordLength = 8;
export const PasswordRegex = [/[a-z]/, /[A-Z]/, /[0-9]/, /[!@#$%^&*\(\)_\+\-\={}<>,\.\|\"'~`:;\\?\/\[\]]/];